import { Image, Text, View } from "@react-pdf/renderer";
import logo from "@packages/assets/logo.png";
import { t } from "i18next";
import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headerSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  headerLogoContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  headerSchoolLogoContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  headerLogo: {
    width: "64px",
    height: "64px",
  },
  headerTitle: {
    width: "100%",
    fontSize: 16,
    fontWeight: 700,
    flex: 3,
  },
  blankContainer: {
    flex: 1,
  },
});

type Props = {
  title?: string;
  school?: string;
};

export default function Header({
  title = t("pdf_renderer.homework"),
  school,
}: Props) {
  // const logoFile = "https://deploy.madlen.io/logo.svg";

  const logoFile = logo;

  if (school) {
    // const schoolLogo = "https://deploy.madlen.io/logo.svg";
    // TODO: get school logo
    const schoolLogo = logo;
    return (
      <View style={styles.headerSection}>
        <View style={styles.headerLogoContainer}>
          <Image src={logoFile} style={styles.headerLogo} />
        </View>
        <Text style={styles.headerTitle}>{title}</Text>
        <View style={styles.headerSchoolLogoContainer}>
          <Image src={schoolLogo} style={styles.headerLogo} />
        </View>
      </View>
    );
  }

  return (
    <View style={styles.headerSection}>
      <View style={styles.headerLogoContainer}>
        <Image src={logoFile} style={styles.headerLogo} />
      </View>
      <Text style={styles.headerTitle}>{title}</Text>
      <View style={styles.blankContainer} />
    </View>
  );
}
